import { forConversation } from '../channels';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const INTERVENED = 'DIALOGUE/INTERVENED';

export interface IIntervenedPayload {
  conversationId: string;
  uid?: string;
}

const payloadSchema = objectSchemaOf<IIntervenedPayload>({
  conversationId: Joi.string().required(),
  uid: Joi.string().optional(),
});

export const intervenedActionSchema = objectSchemaOf<IIntervenedAction>({
  type: Joi.string().required().valid(INTERVENED),
  payload: payloadSchema.required(),
});

export interface IIntervenedAction {
  type: typeof INTERVENED;
  payload: IIntervenedPayload;
}

export const intervened = actionCreator({
  type: INTERVENED,
  schema: intervenedActionSchema,
  channels: [forConversation],
});
